import React from 'react';
import { CheckIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { checkoutUrl, productBrand, productEdition } from '../data/offer';
import { trackInitiateCheckout } from '../utils/metaPixel';
const assurances = ['7-day guarantee', 'Secure payment', 'Instant access'];
export function FinalCta() {
  return <section className="border-t border-steel/40 bg-navy-900 py-16 sm:py-20" aria-labelledby="final-title" data-id="element-61" data-mp="15bsodlj70gm7">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-62" data-mp="1jbai8fbcik2f">
        <h2 id="final-title" className="text-balance text-3xl font-extrabold uppercase tracking-tight text-white sm:text-4xl" data-id="element-63" data-mp="1eets5fkl5vmp">
          <span className="inline-flex items-center gap-2" data-id="element-64" data-mp="1t2ew1bpabyvo">
            <ZapIcon className="h-8 w-8 shrink-0 text-gold" aria-hidden="true" data-id="element-65" data-mp="1o3bqzr9b1snp" /> {productBrand}
          </span>
          <span className="mt-2 block text-xl font-extrabold uppercase tracking-[.16em] text-gold sm:text-2xl" data-id="element-66" data-mp="224o4lw0zti6f">
            {productEdition}
          </span>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-lg leading-relaxed text-steel-light" data-id="element-67" data-mp="n5uj5u3cp9d2">
          Created for electrical technicians, engineers and supervisors in industrial plants, utilities and electrical
          maintenance.
        </p>

        <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" onClick={trackInitiateCheckout} arrow className="mt-8 w-full sm:w-auto" data-id="element-68" data-mp="x2za07855t07">
          Get my professional edition now
        </Button>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-steel-light" data-id="element-69" data-mp="163xdmoeo3yi9">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-70" data-mp="1fu9ua5jd37j4">
              <CheckIcon className="h-4 w-4 text-copper" aria-hidden="true" data-id="element-71" data-mp="1fwcx5q5m4v59" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}